import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";

import {
  createBankAccountStatus,
  createBankAccountStatusSuccess,
  deleteBankAccountStatus,
  deleteBankAccountStatusSuccess,
  getBankAccountStatusList,
  updateBankAccountStatus,
  updateBankAccountStatusSuccess,
} from "../../../../store/bank/action";
export default function BankingSettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagActive: "",
  });

  const { bankAccountStatusListAPI } = useSelector((state) => ({
    bankAccountStatusListAPI:
      state.Bank.bankAccountStatusList?.bankaccountstatus_list,
  }));

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(createBankAccountStatus([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = bankAccountStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    setStatusList(data);
  }, [bankAccountStatusListAPI, activeTab]);

  useEffect(() => {
    dispatch(getBankAccountStatusList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(deleteBankAccountStatus([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(updateBankAccountStatus([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    createBankAccountStatusSuccessAPI,
    deleteBankAccountStatusSuccessAPI,
    updateBankAccountStatusSuccessAPI,
  } = useSelector((state) => ({
    createBankAccountStatusSuccessAPI:
      state.Bank.createBankAccountStatusSuccess,
    deleteBankAccountStatusSuccessAPI:
      state.Bank.deleteBankAccountStatusSuccess,
    updateBankAccountStatusSuccessAPI:
      state.Bank.updateBankAccountStatusSuccess,
  }));
  // Add new Quote Status
  useEffect(() => {
    if (isEmpty(createBankAccountStatusSuccessAPI)) return;
    if (createBankAccountStatusSuccessAPI.status === 200) {
      toast.success(createBankAccountStatusSuccessAPI?.message);
      dispatch(getBankAccountStatusList());
    } else {
      toast.error(createBankAccountStatusSuccessAPI?.message);
    }
    dispatch(createBankAccountStatusSuccess([]));
  }, [createBankAccountStatusSuccessAPI]);

  // Delete Quote Status
  useEffect(() => {
    if (isEmpty(deleteBankAccountStatusSuccessAPI)) return;
    if (deleteBankAccountStatusSuccessAPI.status === 200) {
      toast.success(deleteBankAccountStatusSuccessAPI?.message);
      dispatch(getBankAccountStatusList());

      setDeleteModal(false);
    } else {
      toast.error(deleteBankAccountStatusSuccessAPI?.message);
    }
    dispatch(deleteBankAccountStatusSuccess([]));
  }, [deleteBankAccountStatusSuccessAPI]);

  // Update Quote Status
  useEffect(() => {
    if (isEmpty(updateBankAccountStatusSuccessAPI)) return;
    if (updateBankAccountStatusSuccessAPI.status === 200) {
      toast.success(updateBankAccountStatusSuccessAPI?.message);
      dispatch(getBankAccountStatusList());
    } else {
      toast.error(updateBankAccountStatusSuccessAPI?.message);
    }
    dispatch(updateBankAccountStatusSuccess([]));
  }, [updateBankAccountStatusSuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Banking Settings"
        description="Statuses for your bank accounts."
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          bankAccountStatus={true}
        />
      </SettingsPanel>
    </>
  );
}
